(function() {
    'use strict';

    angular.module('remitEventsFilters', []).filter('dayspan', function(EventFilter) {
        return function(events) {
            var currDay = null;
            var currDayCount = 0;
            var firstEventWithCurrDate = null;

            _.each(events, function(event) {
                var day = moment(event.publicationDate).startOf('day');

                if (day.isSame(currDay)) {
                    if (EventFilter.shouldBeShown(event)) {
                        if (firstEventWithCurrDate) {
                            currDayCount++;
                            event.showDate = false;
                        } else {
                            currDayCount = 1;
                            firstEventWithCurrDate = event;
                            event.showDate = true;
                        }
                    } else {
                        event.showDate = true;
                    }
                } else {
                    currDay = day;
                    event.showDate = true;
                    if (firstEventWithCurrDate) {
                        firstEventWithCurrDate.sameDayCount = currDayCount;
                    }

                    if (EventFilter.shouldBeShown(event)) {
                        currDayCount = 1;
                        firstEventWithCurrDate = event;
                    } else {
                        firstEventWithCurrDate = null;
                    }
                }

                if (firstEventWithCurrDate) {
                    firstEventWithCurrDate.sameDayCount = currDayCount;
                }
            });

            return events;
        };
    });
})();
